import React from 'react'
import { reduxForm, Field } from 'redux-form'

import Card from '../../Shared/Card'
import Button from '../../Shared/Button'
import WrappedInput from '../../Shared/Forms/WrappedInput'
import TypeMenu from '../Configure/Inputs/TypeMenu'

const FORM_NAME = 'addInputModalForm'

const Form = function AddInputForm({
  handleSubmit,
  submitting,
  error,
  onCancel,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <Card
        actions={
          <>
            <Button text type="button" onClick={onCancel}>
              Cancel
            </Button>
            <Button loading={submitting}>Add Input</Button>
          </>
        }
      >
        <h1>Add New Input</h1>
        <Field
          component={WrappedInput}
          name="input.name"
          placeholder="Enter name..."
          label="Name"
        />
        <Field component={TypeMenu} name="input" />
      </Card>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAME,
})(Form)
